(() => {
  let activeSync = null;

  function setCartCount(count) {
    try {
      sessionStorage.setItem('cart-count', JSON.stringify({ value: String(count), timestamp: Date.now() }));
    } catch (_) {}

    customElements.whenDefined('cart-icon').then(() => {
      document.querySelectorAll('cart-icon').forEach((icon) => {
        if (typeof icon.renderCartBubble === 'function') {
          icon.renderCartBubble(count, false);
          return;
        }
        const countNode = icon.querySelector('.cart-bubble__text-count');
        if (countNode) countNode.textContent = count > 0 && count < 100 ? String(count) : '';
        icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
      });
    });
  }

  async function refreshDrawer() {
    const currentSection = document.querySelector('#shopify-section-cart-drawer-section');
    if (!currentSection) return;

    const currentDrawer = currentSection.querySelector('#cart-drawer');
    const wasOpen = currentDrawer?.hasAttribute('open') || currentDrawer?.querySelector('dialog')?.open;

    const url = new URL(window.location.href);
    // Keep Shopify preview/variant parameters so Section Rendering uses the same draft theme.
    url.searchParams.set('section_id', 'cart-drawer-section');
    url.searchParams.set('_ce', Date.now().toString());

    const response = await fetch(url.toString(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) return;

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const freshSection = doc.querySelector('#shopify-section-cart-drawer-section');
    if (!freshSection) return;

    currentSection.replaceWith(freshSection);

    if (wasOpen) {
      const freshDrawer = document.querySelector('#cart-drawer');
      customElements.whenDefined('theme-drawer').then(() => {
        if (typeof freshDrawer?.open === 'function') freshDrawer.open();
      });
    }
  }

  async function syncCart({ drawer = false } = {}) {
    if (activeSync) return activeSync;

    activeSync = (async () => {
      try {
        const response = await fetch('/cart.js?_ce=' + Date.now(), {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) return;

        const cart = await response.json();
        setCartCount(cart.item_count || 0);
        if (drawer) await refreshDrawer();
      } catch (error) {
        console.warn('[CarbonERA cart sync]', error);
      }
    })().finally(() => {
      activeSync = null;
    });

    return activeSync;
  }

  // Browser back from checkout can restore stale HTML from the bfcache.
  window.addEventListener('pageshow', () => syncCart({ drawer: true }));
  window.addEventListener('focus', () => syncCart({ drawer: false }));
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') syncCart({ drawer: false });
  });

  // Normal cart clicks must not replace/re-open the drawer.
  // Shopify owns the drawer open animation; we only refresh the count here.
  document.addEventListener('pointerdown', (event) => {
    if (event.target instanceof Element && event.target.closest('[data-testid="cart-drawer-trigger"]')) {
      syncCart({ drawer: false });
    }
  }, true);

  // Make the helper callable after any future custom cart action.
  window.CarbonERACartSync = () => syncCart({ drawer: true });
})();